<template>
  <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
    <v-flex xs6 class="inline-block px-4">
      <v-text-field hide-details :label="$t('Admin.UmbType.Form.Key')" v-model="umt_key" />
      <v-text-field hide-details :label="$t('Admin.UmbType.Form.Surname')" v-model="umt_libelle" />
      <v-autocomplete
        hide-details
        :items="umbClasses"
        item-text="UMC_LIBELLE"
        item-value="UMC_ID"
        :label="$t('Admin.UmbType.Form.UmbClasse')"
        v-model="umc_id"
      ></v-autocomplete>
      <v-text-field
        hide-details
        type="number"
        :label="$t('Admin.UmbType.Form.MaxPressure')"
        v-model.number="umt_max_press"
      />
      <v-text-field
        hide-details
        type="number"
        :label="$t('Admin.UmbType.Form.ConsoMoy')"
        v-model.number="umt_moy_conso"
      />
      <v-text-field hide-details :label="$t('Admin.UmbType.Form.Maker')" v-model="umt_fabricant" />
      <v-text-field hide-details :label="$t('Admin.UmbType.Form.Integrator')" v-model="umt_integrateur" />
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminUmbTypeForm',
})
export default class AdminUmbTypeForm extends Vue {
  created() {
    this.$store.myActions.UMBCLASSE_ENSURE_LIST()
  }

  get umbClasses() {
    return this.$store.myGetters.umbClasses
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmUmbType
  }

  get umc_id() {
    return this.modified.UMC_ID!
  }
  set umc_id(value: number) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMC_ID: value,
    })
  }

  get umt_key() {
    return this.modified.UMT_KEY!
  }
  set umt_key(value: string) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_KEY: value,
    })
  }

  get umt_libelle() {
    return this.modified.UMT_LIBELLE!
  }
  set umt_libelle(value: string) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_LIBELLE: value,
    })
  }

  get umt_fabricant() {
    return this.modified.UMT_FABRICANT!
  }
  set umt_fabricant(value: string) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_FABRICANT: value,
    })
  }
  get umt_integrateur() {
    return this.modified.UMT_INTEGRATEUR!
  }
  set umt_integrateur(value: string) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_INTEGRATEUR: value,
    })
  }

  get umt_max_press() {
    return this.modified.UMT_MAX_PRESS!
  }
  set umt_max_press(value: number) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_MAX_PRESS: value,
    })
  }

  get umt_moy_conso() {
    return this.modified.UMT_MOY_CONSO!
  }
  set umt_moy_conso(value: number) {
    this.$store.myActions.UMBTYPE_UPDATE_MODIFIED_ADM({
      UMT_MOY_CONSO: value,
    })
  }
}
</script>
